import api from "./API";

// Withdraw
export const WithDrawRequest = async (userData: any) =>
  (await api.put("Account/WithDrawRequest", userData)).data;

export const WithDrawRequestAction = async (userData: any) =>
  (await api.patch("Account/WithDraw", userData)).data;

// Payment
export const paymentRequest = async (userData: any) =>
  (await api.put("Account/Payment", userData)).data;

export const paymentRequestAction = async (userData: any) =>
  (await api.patch("Account/PackageActivation", userData)).data;

// Courses
export const courseOrder = async (userData: any) =>
  (await api.put("Courses/CourseOrder", userData, {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;

// Account
export const heighestEarnerOfWeek = async () =>
  (await api.get("Account/heighestEarnerOfWeek")).data;

export const getAccountDetails = async (showDetail: number = 1) =>
  (await api.get(`Account/AccountDetail?ShowDetail=${showDetail}`)).data;

export const getAccountWallet = async (userData: any) =>
  (await api.patch("Account/Wallet", userData)).data;

export const actionBeneficiary = async (userData: any) =>
  (await api.patch("Account/ActionBeneficiary", userData)).data;

export const addBeneficiary = async (userData: any) =>
  (await api.put("Account/AddBeneficiary", userData)).data;

// Auth
export const APIEventAndPayment = async (userData: any) =>
  (await api.patch("Auth/EventAndPayment", userData, {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;

// Coupon
export const APICouponCode = async (userData: any) =>
  (await api.patch("Account/CouponCode", userData)).data;

// Notification
export const Notification = async (userData: any) =>
  (await api.post("Account/AdminNotification", userData)).data;
